module.exports = __webpack_public_path__ + "img/img_2.d15d859e.png";